var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"share-404"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("../assets/imgs/share-404-3x.png")}})]),_c('div',{staticClass:"explain"},[_vm._v(" 请使用手机微信打开小程序 "),_c('span',[_vm._v("（需6.5.6及以上版本，暂不支持iPad客户端）")])])])
}]

export { render, staticRenderFns }